import * as S from "./style"

const Footer = () => {
    return (
        <S.Container>
            <S.MenuTitle>이용안내</S.MenuTitle>
        </S.Container>
    );
};

export default Footer;